import "./style.scss";
import "hamburgers";
import React, { useState, useEffect } from "react";
import clsx from "clsx";

type Props = {
  onToggle?: (open: boolean) => void;
};

export const Burger: React.FC<Props> = ({ onToggle }) => {
  const [open, setOpen] = useState<boolean>(false);

  useEffect(() => {
    if (onToggle) onToggle(open);
  }, [open, onToggle]);

  return (
    <button
      className={clsx("burger hamburger hamburger--collapse", {
        "is-active": open,
      })}
      type="button"
      onClick={() => setOpen(!open)}
    >
      <span className="hamburger-box">
        <span className="hamburger-inner"></span>
      </span>
    </button>
  );
};
